export default () => ({
  buttonLoading: false,
});
